import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';

export const styles = StyleSheet.create({
  firstOrderPadding: {
    paddingVertical: indent,
    paddingRight: indent * 0.2,
    paddingLeft: indent,
  },
  noOrderPadding: {
    padding: indent,
  },
  firstOrderStatusContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
});
